import { Timeframe } from "@opensea/graphql"
import { toLowerCase, toUpperCase } from "@opensea/utils"
import { parseAsStringLiteral, useQueryState } from "nuqs"
import { useFilterDefaults } from "@/components/layout/FilterDefaultsProvider"
import { QUERY_PARAM_KEYS } from "./keys"

export const DEFAULT_STATS_TIMEFRAME = "ONE_DAY" as const satisfies Timeframe

const parser = parseAsStringLiteral(Timeframe.map(v => toLowerCase(v)))

export function useStatsTimeframeQueryParam() {
  const { timeframe: defaultTimeframe } = useFilterDefaults()

  const [timeframe, setTimeframe] = useQueryState(
    QUERY_PARAM_KEYS.timeframe,
    parser.withDefault(
      toLowerCase(defaultTimeframe ?? DEFAULT_STATS_TIMEFRAME),
    ),
  )

  async function onSelectTimeframe(value: Timeframe) {
    await setTimeframe(value === defaultTimeframe ? null : toLowerCase(value))
  }

  return { timeframe: toUpperCase(timeframe), onSelectTimeframe }
}
